import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ITransformedUser } from "helpers/transforms/user";
import { IRootStateProps } from "types/reducers";
import { RequestStatus } from "types/requests";

import { HQ_SERVICE, LOGIN_ROUTE } from "constants/app";

import { getUser } from "interfaces/user";

type UserActionTypes = IReceiveUserAction | IRequestUserAction;

type UserThunkResult<R> = ThunkAction<
  R,
  IRootStateProps,
  undefined,
  UserActionTypes
>;

enum UserTypeKeys {
  REQUEST_USER = "USER/REQUEST_USER",
  RECEIVE_USER = "USER/RECEIVE_USER",
}

interface IReceiveUserAction {
  type: UserTypeKeys.RECEIVE_USER;
  appUser: ITransformedUser;
  userRequestStatus: RequestStatus;
}

function receiveUser(appUser: ITransformedUser): IReceiveUserAction {
  return {
    type: UserTypeKeys.RECEIVE_USER,
    appUser,
    userRequestStatus: RequestStatus.SUCCESS,
  };
}

interface IRequestUserAction {
  type: UserTypeKeys.REQUEST_USER;
  userRequestStatus: RequestStatus;
}

// Used by fetchUser to set the user request status to Requesting
function requestUser(): IRequestUserAction {
  return {
    type: UserTypeKeys.REQUEST_USER,
    userRequestStatus: RequestStatus.REQUESTING,
  };
}

// Issues the user request and sets the request status to Requesting
function fetchUser(): UserThunkResult<void> {
  return (dispatch: Dispatch): Promise<void> => {
    dispatch(requestUser());

    return getUser()
      .then((user: ITransformedUser) => {
        dispatch(receiveUser(user as ITransformedUser));
      })
      .catch(() => {
        // Push the user to an hq service endpoint which will push them to auth0 for authentication
        window.location.href = `${HQ_SERVICE}${LOGIN_ROUTE}?prompt=none&return_to=${encodeURI(
          window.location.href
        )}`;
      });
  };
}

export { fetchUser, UserTypeKeys, UserActionTypes, UserThunkResult };
